export const MAX_INVOICES_PER_PAYMENT = 30;
export const MIN_AMOUNT_PAYMENT_ADVANCE_DT = 5000;
export const MIN_AMOUNT_PAYMENT_ADVANCE_PR = 30000;
